import * as React from 'react';
import ShadowContainer from 'src/components/atomsLegacy/containers/ShadowContainer';
import { ModalWrapper } from '../../../Reporting/ReportingLoginContainer/ReportingLoginContainer.styles';

interface Props {
  children: React.ReactNode;
  loggedInUser?: boolean;
}

const LoginContainerModal = (props: Props) => {
  return (
    <ShadowContainer setMinHeight={false}>
      <ModalWrapper>{props.children}</ModalWrapper>
    </ShadowContainer>
  );
};

export default LoginContainerModal;
